import { DisconnectReason, ModalButtonAction } from "@alien-game-server/sdk"
import { Icon } from "@game/Icon";
import { ModalButton, ModalButtonTypes } from "@game/SdkModal";
 
import { App } from "@system/App"
 
import { openHistoryUrl } from "@utils/helpers";
 

export class ModalHandler{
  
    nickname: string = ""

    realityCheck: string | undefined = undefined;
    showLobby: boolean = true;
    showHome: boolean = true;

    
    constructor(){
        //this.testDisconnectModal()
      //  setTimeout(()=>{this.showDisconnectModal()},4000)
    }

    showModal(reason: DisconnectReason){
      switch(reason){
        case DisconnectReason.IDLE:
          this.showDisconnectModal()
          break;
        case DisconnectReason.ANOTHER_LAUNCH:
          this.showMultiSessionModal()
          break;
        case DisconnectReason.UNKNOWN:
          this.showDisconnectModal()
          break;
      }
      
    }

    setShowModal(title: string, description: string,time?: number){
     App.classicCrash.sdkModal?.show(time);
     App.classicCrash.sdkModal?.setTitle(title,description);
      
  }

    setNickname(input: string){
      const isValid = (/^[A-Za-z0-9]*$/).test(input);
      if(isValid){
          this.nickname = input
      }
      const ret = input.length >= 3
      return {nickname: this.nickname, isValid: ret && isValid}
    }

    showInsufficiantFunds(params:{condition:boolean}){
      if(!params.condition) return 
     App.postMessagesManager.emitInsufficientFunds()
      const title = App.classicCrash.translate("insufficientFundsModalTitle")
      const description = App.classicCrash.translate("insufficientFundsModalDescription")
      this.setShowModal(title, description)
     App.classicCrash.sdkModal?.setButtons([
        {action:ModalButtonAction.CLOSE_MODAL,
          type: ModalButtonTypes.secondary,
          title:  App.classicCrash.translate("okBtn"),
       
        },
      ])
  }

  showDisconnectModal(){
    const homeButton: ModalButton = {
      action:ModalButtonAction.BACK_TO_HOME,
      type: ModalButtonTypes.tertiary,
      title: App.classicCrash.translate("backToHomeBtn"),
      icon: Icon.getSVG({iconType: 'home', color:'white',size:18,className:'menu-icon'}),
    }
    const LobbyButton: ModalButton = {
      action:ModalButtonAction.REDIRECT_TO_LOBBY,
      type: ModalButtonTypes.secondary,
      title: App.classicCrash.translate("lobbyMenuLabel")
    } 
    const buttonsToAdd = []
    if(this.showHome){
      buttonsToAdd.push(homeButton)
    }
    //  if(this.showLobby){
    //   buttonsToAdd.push(LobbyButton)
    // }
    let descriptionKey = "disconnectedModalDescription"
    if( !this.showHome){
      descriptionKey = "disconnectedModalDescriptionNoLobbyNoHome"
    }else if(this.showHome){
      descriptionKey = "disconnectedModalDescriptionNoLobby"
    }
    const title = App.classicCrash.translate("disconnectedModalTitle")
    const description = App.classicCrash.translate(descriptionKey)
    this.setShowModal(title, description)
   App.classicCrash.sdkModal?.setButtons(buttonsToAdd)
}

  showIdleModal(time?: number){
    const homeButton: ModalButton = {
      action:ModalButtonAction.BACK_TO_HOME,
      type: ModalButtonTypes.tertiary,
      title: App.classicCrash.translate("backToHomeBtn"),
      icon: Icon.getSVG({iconType: 'home', color:'white',size:18,className:'menu-icon'}),
    }
    const LobbyButton: ModalButton = {
      action:ModalButtonAction.REDIRECT_TO_LOBBY,
      type: ModalButtonTypes.secondary,
      title: App.classicCrash.translate("lobbyMenuLabel")
    } 

    const ContinueButton: ModalButton = {
      action:ModalButtonAction.RENEW_SESSION,
      type: ModalButtonTypes.primary,
      title: App.classicCrash.translate("continueLabel")
    } 
    const buttonsToAdd = []
    if(this.showHome){
      buttonsToAdd.push(homeButton)
    }
    if(this.showLobby){
      buttonsToAdd.push(LobbyButton)
    }
    buttonsToAdd.push(ContinueButton)

    const title = App.classicCrash.translate("idleModalTitle")
    const description = App.classicCrash.translate("idleModalDescription")
    this.setShowModal(title, description,time)
   App.classicCrash.sdkModal?.setButtons(buttonsToAdd)
  }

  showMultiSessionModal(){
    const homeButton: ModalButton = {
      action:ModalButtonAction.BACK_TO_HOME,
      type: ModalButtonTypes.primary,
      title: App.classicCrash.translate("backToHomeBtn"),
      icon: Icon.getSVG({iconType: 'home', color:'white',size:18,className:'menu-icon'}),
    }
    const title = App.classicCrash.translate("anotherLaunchModalTitle")
    const description = App.classicCrash.translate("anotherLaunchModalDescription")
    this.setShowModal(title, description)
   App.classicCrash.sdkModal?.setButtons([homeButton])
  }

  setRealityCheckData(data: string | undefined ){
    this.realityCheck = data
    if(this.realityCheck){
      sessionStorage.setItem("realityCheckLastHiddenAt", String(Date.now()));
      this.checkReality()
    }
  }

  checkReality(){
    if(!this.realityCheck) return;
    setTimeout(() => {this.checkReality()}, 10 * 1000)
    try{
        let lastHiddenTime = Number(sessionStorage.getItem("realityCheckLastHiddenAt"));
        if (!lastHiddenTime) {
          lastHiddenTime = Date.now()
          sessionStorage.setItem("realityCheckLastHiddenAt", String(lastHiddenTime));
        }

        const data = JSON.parse(this.realityCheck) as {
            "schemaVersion": "1",
            "realityCheckIntervalMinutes": 1,
            "historyUrl" : "https://imoon.com"
        }

        // const data =  {
        //     "schemaVersion": "1",
        //     "realityCheckIntervalMinutes": 0.1,
        //     "historyUrl" : "https://imoon.com"
        // }

        const timeElapsed = Date.now() - lastHiddenTime;
        if (timeElapsed < data.realityCheckIntervalMinutes * 60 * 1000){ 
          return
        }

        if(!App.classicCrash.sdkModal) return
        if(!App.classicCrash.sdkModal.isHidden()) return
          const title = App.classicCrash.translate("realityCheckTitle")
          const description =  App.classicCrash.translate("realityCheckDescription").replace("{{realityCheckIntervalMinutes}}",data.realityCheckIntervalMinutes.toString())
          this.setShowModal(title, description)
          const exitAction = App.sdk?.homeConfig.homeUrl ? ModalButtonAction.BACK_TO_HOME : ModalButtonAction.DISCONNECT_GAME
          App.classicCrash.sdkModal.setHeaderIcon("history", () => {
            if (data.historyUrl) {
                openHistoryUrl(data.historyUrl)
            } else {
                //   App.emitter.emit(App.config.events.OPEN_HISTORY)
                document.body.classList.add('rc')

            }
        })
          App.classicCrash.sdkModal?.setButtons( [{action: ModalButtonAction.CLOSE_MODAL,
                type: ModalButtonTypes.primary,
                title: App.classicCrash.translate("continueLabel"),
              },
              {action: exitAction,
                type:  ModalButtonTypes.primary,
                title: App.classicCrash.translate("exitLabel"),
              }]
          );              
          sessionStorage.setItem("realityCheckLastHiddenAt", String(Date.now()));
        }
        catch(e: any){
          //console.log("Failed to parse reality check")
        }
  }

  showLobbyModal(){

    const title = App.classicCrash.translate("notificationLabel")
    const description = App.classicCrash.translate("imoonLobbyDescription")
    this.setShowModal(title, description)
    App.classicCrash.sdkModal?.setButtons([
      {action:ModalButtonAction.CLOSE_MODAL,
        type:ModalButtonTypes.secondary,
        title:  App.classicCrash.translate("noLabel"),
    
      },
      {action:ModalButtonAction.REDIRECT_TO_LOBBY,
        type:ModalButtonTypes.primary,
        title:  App.classicCrash.translate("yesLabel"),
    
      },
   
    ])
}

 


   
 


}
